import React from "react";
import { motion, useInView } from "framer-motion";
import { features } from "@/utils/icons/start/features.js";
import { FaQuoteLeft } from "react-icons/fa";

function AboutUs() {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section ref={ref} className="py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-6 text-gray-800">Sobre Nosotros</h2>
          <div className="w-24 h-1 bg-[var(--gold)] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            En LawFeed, nuestra misión es simplificar el acceso a servicios legales de calidad. Conectamos a
            clientes con los mejores bufetes de abogados, asegurando transparencia, confianza y excelencia en cada
            interacción.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 mb-20">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg text-center transform hover:-translate-y-2 transition-transform duration-300"
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="bg-[var(--beige)] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
                {React.cloneElement(feature.icon, { className: "text-5xl text-[var(--gold)] " })}
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-gray-800">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="bg-[var(--navy-blue)] text-white p-12 rounded-xl shadow-2xl relative overflow-hidden"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <div className="absolute top-0 left-0 w-full h-full bg-blue-500 opacity-50 transform -skew-y-6"></div>
          <div className="relative z-10">
            <FaQuoteLeft className="text-5xl text-blue-300 mb-6" />
            <h3 className="text-3xl font-bold mb-6">Nuestra Visión</h3>
            <p className="text-xl leading-relaxed mb-8">
              Aspiramos a transformar la industria legal, haciéndola más accesible, transparente y eficiente para todos.
              Creemos en un mundo donde cada persona tenga acceso a la justicia y representación legal de calidad.
            </p>
            <div className="flex justify-center">
              <motion.button
                className="bg-white border-white text-[var(--gold)] px-8 py-3 rounded-full font-semibold hover:bg-[var(--gold-dark)] hover:border-[var(--gold-dark)] hover:text-white transition-colors duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Conoce Más
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default AboutUs;